import React from 'react';
const links = [{
  label: '3 Lenses',
  href: '#lenses'
}, {
  label: 'How it works',
  href: '#how'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'Support',
  href: '#support'
}];
export function SiteNav() {
  return <header className="sticky top-0 z-40 border-b border-white/10 bg-ink-950/95 backdrop-blur" data-id="element-856" data-mp="3aly12i0b1xwi">
      <nav aria-label="Main" className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8" data-id="element-857" data-mp="35nehgo96oy7b">
        <a href="#top" className="shrink-0" data-id="element-858" data-mp="2wnrehy0t3kc5">
          <span className="block font-display text-2xl font-extrabold uppercase leading-none tracking-tight text-offwhite sm:text-3xl" data-id="element-859" data-mp="2wmokhh86t1s0">
            Grit<span className="text-grit-500" data-id="element-860" data-mp="2mpbltqm4s30j">Vue</span>
            <sup className="ml-0.5 align-super text-[9px] text-steel-400" data-id="element-861" data-mp="2mqll2j4pzh8r">™</sup>
          </span>
          <span className="mt-0.5 block text-[8px] font-semibold uppercase tracking-[0.3em] text-steel-400 sm:text-[9px]" data-id="element-862" data-mp="pvqmuzhn7hro">
            See the job through
          </span>
        </a>

        <ul className="hidden items-center gap-8 lg:flex" data-id="element-863" data-mp="8zcggmgp4yky">
          {links.map(link => <li key={link.href} data-id="element-864" data-mp="dyyw12jzyqwx">
              <a href={link.href} className="text-xs font-bold uppercase tracking-[0.16em] text-steel-300 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-865" data-mp="e0091ckkpnha">
                {link.label}
              </a>
            </li>)}
        </ul>

        <a href="#offer" className="inline-flex shrink-0 items-center bg-grit-500 px-3.5 py-2.5 font-display text-base font-extrabold uppercase leading-none tracking-wide text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] sm:px-4 sm:text-lg" data-id="element-866" data-mp="rqvjuuemueni">
          Get your X1
        </a>
      </nav>

      <ul aria-label="Sections" className="flex gap-5 overflow-x-auto border-t border-white/10 px-4 py-2.5 [-ms-overflow-style:none] [scrollbar-width:none] lg:hidden [&::-webkit-scrollbar]:hidden" data-id="element-867" data-mp="1aneob6ehredq">
        {links.map(link => <li key={link.href} data-id="element-868" data-mp="1kctq75b7a9l7">
            <a href={link.href} className="whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.16em] text-steel-300 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-869" data-mp="1kdvb01i0qag4">
              {link.label}
            </a>
          </li>)}
      </ul>
    </header>;
}